export const ApiGetComments = Symbol('ApiGetComments');
